import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SettingsService} from "../../../service/settings.service";
import {PopupComponent} from "../../../shared/popup/popup.component";
import {PROJECT_MESSAGES} from "../../../config/project";
import {LoaderService} from "../../../service/loader.service";

@Component({
    selector: 'app-popup-settings-square',
    templateUrl: './popup-settings-square.component.html',
    styleUrls: ['./popup-settings-square.component.scss']
})
export class PopupSettingsSquareComponent implements OnInit {
    @Input() show: boolean;
    @Output('onClose') emitClose: EventEmitter<any> = new EventEmitter();

    popupForm: FormGroup;

    constructor(private formBuilder: FormBuilder,
                private popupComponent: PopupComponent,
                private loaderService: LoaderService,
                private settingsService: SettingsService) {
        this.popupForm = this.formBuilder.group({
            name: [null, Validators.required],
            applicationId: [null, Validators.required],
            locationId: [null, Validators.required],
            accessToken: [null, Validators.required]
        });
    }

    ngOnInit() {}

    ngOnChanges(changes) {
    }

    closePopup(needUpdate = false) {
        this.popupForm.reset();
        this.emitClose.emit(needUpdate);
    }

    onSubmit() {
        const name = this.popupForm.controls.name.value;
        const applicationId = this.popupForm.controls.applicationId.value;
        const locationId = this.popupForm.controls.locationId.value;
        const accessToken = this.popupForm.controls.accessToken.value;
        if (name && applicationId && locationId && accessToken) {
            this.settingsService.addSquareItem(name, applicationId, locationId, accessToken).subscribe((data) => {
                this.handleSubmitResult(data);
            }, () => {
                this.loaderService.hideAndShowTryAgain();
            }, () => {
                this.loaderService.hide();
            });
        } else {
            this.popupComponent.showPopupError({text: PROJECT_MESSAGES.notAllFieldsAreFilled});
        }
    }

    handleSubmitResult(data) {
        try {
            if (data.status) {
                this.popupComponent.showPopupSuccess({text: data.message});
                this.closePopup(true);
            } else {
                this.popupComponent.showPopupError({text: data.message});
            }
        } catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }
    }
}
